module.exports = __webpack_public_path__ + "static/media/all-fp-dark.bf43a96a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/all-fp-dark.svg
// module id = 353
// module chunks = 7